<template>
    <ul :class="['ui-tab-list']">
        <li v-for="(tab, index) in tabs" :class="['ui-tab-list__item', active === index ? 'active' : '']">
            <a :href="tab.href" @click="() => handleClick(tab)" :class="['ui-tab-list__item__button']">
                <span>{{ tab.title }}</span>
            </a>
        </li>
    </ul>
</template>

<script>
    export default {
        name: 'ui-tab-list',
        props: ['tabs', 'active', 'callback'],
        methods: {
            handleClick(tab) {
                if (typeof tab.onClick === 'function') {
                    tab.onClick(tab);
                }
                if (typeof this.callback === 'function') {
                    console.log('has callback');
                    this.callback();
                }
            },
        },
    };
</script>

<style>
    .ui-tab-list {
        padding: 5px;
    }

    .ui-tab-list__item {
        padding: 2px;
    }

    .ui-tab-list__item__button {
        padding: 6px 8px;
        width: 100%;
        border-radius: 6px;
        font-size: 1.05em;
        line-height: 100%;
        color: rgba(0, 0, 0, .8);
        display: block;
        cursor: pointer;
        text-decoration: none;
    }

    .ui-tab-list__item__button:hover {
        background-color: rgba(0, 0, 0, .05);
    }

    .ui-tab-list__item.active .ui-tab-list__item__button {
        background-color: rgba(0, 0, 0, .5);
        color: #FFF;
    }
</style>



// WEBPACK FOOTER //
// UiTabList.vue?312c2f2b